// @flow
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import type { StateType, DispatchType } from "../../../global/types/redux";
import { LoadingProgress, AppHeader } from "imagus-components";
import { fetchCurrentBilling } from "../../actions/billingActions";
import BillingPaymentInfo from "../../components/billings/BillingPaymentInfo";
import CurrentBilling from "../../components/billings/CurrentBilling";
import HistoryBillingRedux from "./HistoryBillingsRedux";

import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";

class MyBilling extends Component<*> {
  componentDidMount() {
    this.props.actions.fetchCurrentBilling();
  }

  render(): * {
    const billing = this.props.billing;

    if (!billing) {
      return <LoadingProgress />;
    } else {
      return (
        <Fragment>
          <AppHeader title="My Bills" />
          <div className="app-panel">
            <div className="app-panel-content">
              <Grid container spacing={24}>
                <Grid item xs={12} md={6}>
                  {billing.currentBilling && (
                    <CurrentBilling estimate={billing.currentBilling} />
                  )}
                </Grid>
                <Grid item xs={12} md={6}>
                  {billing.company && (
                    <BillingPaymentInfo company={billing.company} />
                  )}
                  <div style={{ width: "100%", height: "16px" }} />
                  {billing.historyBillings && (
                    <HistoryBillingRedux histories={billing.historyBillings} />
                  )}
                </Grid>
              </Grid>
            </div>
          </div>
        </Fragment>
      );
    }
  }
}

const mapStateToProps = (state: StateType): * => ({
  billing: state.v3account.billing
});

const mapDispatchToProps = (dispatch: DispatchType): DispatchType => ({
  actions: bindActionCreators({ fetchCurrentBilling }, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MyBilling);
